import Vue from 'vue';
import { Carousel3d, Slide } from 'vue-carousel-3d';

function Carousel3ds() {
  const self = this;

  self.init = function init(element) {
    const $el = $(element);

    if ($el.data('app-module-initialized')) return; // Prevent double init

    const slides = $el.data('slides');

    if (!slides || !slides.length) return;

    new Vue({
      el: element,
      data: {
        carouselControls: true,
        controlsWidth: 44,
        controlsHeight: 44,
        controlsPrevHtml: `
          <div class="carousel-3d__ctrl">
            <svg class="carousel-3d__ctrl-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100">
              <path d="M70.6,72c3,2.7,3.1,7.3,0.4,10.3c-0.1,0.1-0.2,0.3-0.4,0.4c-3.2,3-8.3,3-11.6,0L29.4,55.3c-3-2.7-3.2-7.3-0.5-10.2 c0.2-0.2,0.4-0.4,0.5-0.5l29.6-27.4c3.3-2.9,8.3-2.9,11.6,0c3,2.7,3.1,7.3,0.4,10.3c-0.1,0.1-0.2,0.3-0.4,0.4L46.8,50L70.6,72z"/>
            </svg>
          </div>`,
        controlsNextHtml: `
          <div class="carousel-3d__ctrl">
            <svg class="carousel-3d__ctrl-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100">
              <path d="M29.4,28c-3-2.7-3.1-7.3-0.4-10.3c0.1-0.1,0.2-0.3,0.4-0.4c3.2-3,8.3-3,11.6,0l29.6,27.4c3,2.7,3.2,7.3,0.5,10.2 c-0.2,0.2-0.4,0.4-0.5,0.5L40.9,82.8c-3.3,2.9-8.3,2.9-11.6,0c-3-2.7-3.1-7.3-0.4-10.3c0.1-0.1,0.2-0.3,0.4-0.4L53.2,50L29.4,28z"/>
            </svg>
          </div>`,
        slideWidth: 540,
        slideHeight: 350,
        slideBorder: 0,
        slideSpace: 240,
        slidePerspective: 10,
        slideScaling: 200,
        animationSpeed: 500,
        startIndex: 0,
        autoplayEnabled: false,
        visible: 3,
        direction: 'rtl',
        infinite: true,
        disable3d: false,
        slides,
      },
      render(h) {
        const slides = this.slides.map((slide, index) => h(Slide, {
          props: {
            index,
            key: index,
          },
        }, [h('img', { domProps: { src: slide.src } })]));

        const carousel = h(Carousel3d, {
          props: {
            count: this.slides.length,
            controlsVisible: this.carouselControls,
            controlsPrevHtml: this.controlsPrevHtml,
            controlsNextHtml: this.controlsNextHtml,
            controlsWidth: this.controlsWidth,
            controlsHeight: this.controlsHeight,
            width: this.slideWidth,
            height: this.slideHeight,
            autoplay: this.autoplayEnabled,
            disable3d: this.disable3d,
            space: this.slideSpace,
            perspective: this.slidePerspective,
            display: this.visible,
            loop: this.infinite,
            animationSpeed: this.animationSpeed,
            dir: this.direction,
            border: this.slideBorder,
            startIndex: this.startIndex,
            inverseScaling: this.slideScaling,
          },
        }, slides);

        return h('div', { class: { 'carousel-3d': true } }, [carousel]);
      },
    });

    $el.data('app-module-initialized', true);
  };

  self.initAll = function initAll() {
    $('.js-carousel-3d').each(function init() {
      self.init(this);
    });
  };
}

export default new Carousel3ds();
